import { createFileRoute } from "@tanstack/react-router";
import { AdServiceLanding } from "@/components/ads/AdServiceLanding";
import skaggAsset from "@/assets/opt/skagg-tailors-barber.webp";
export const Route = createFileRoute("/barberare-stockholm-ahlens-city/skagg")({
  head: () => ({
    meta: [
      { title: "Skäggtrimning Stockholm City · 380 kr | Tailor's Barber Åhléns" },
      { name: "description", content: "Professionell skäggtrimning i Stockholm City för 380 kr. Boka hos Tailor's Barber Åhléns City – 1 min från T-Centralen." },
      { name: "robots", content: "noindex, follow" },
    ],
  }),
  component: () => (
    <AdServiceLanding
      reviewService="skägg"
      heroImage={skaggAsset}
      heroImageAlt="Skäggtrimning hos Tailor's Barber Åhléns City Stockholm"
      eyebrow="Tailor's Barber · Åhléns City · 1 min från T-Centralen"
      h1="Skäggtrimning i Stockholm City"
      priceBadge="380 kr"
      salon="ahlens-city"
      primaryCtaLabel="Boka Skäggtrimning →"
      primaryCtaHref="https://www.bokadirekt.se/boka-tjanst/tailors-barber-stockholm-ahlens-city-37678/skagg-trimning-1247227?utm_source=google&utm_medium=cpc&utm_campaign=ahlens-city"
      secondary="Drop-in välkommen i mån av tid"
      included={[
        { title: "Konsultation", desc: "Form och längd anpassas efter din ansiktsform." },
        { title: "Trimning & formning", desc: "Maskin, sax och rakkniv." },
        { title: "Konturering", desc: "Skarpa linjer längs halsen och kinderna." },
        { title: "Skäggstyling", desc: "Avslutas med Tailor's Grooming skäggprodukter." },
      ]}
      priceBox="Skäggtrimning: 380 kr · Hår + Skägg-paket: 680 kr"
      faq={[
        { q: "Hur lång tid tar skäggtrimning?", a: "20–30 minuter." },
        { q: "Använder ni rakkniv?", a: "Ja, vid behov avslutar vi med rakkniv för extra skarpa linjer." },
        { q: "Kan jag kombinera med klippning?", a: "Ja, Hår + Skägg-paketet kostar 680 kr totalt." },
        { q: "Vilka skäggprodukter använder ni?", a: "Vi använder Tailor's Grooming-serien, som också finns att köpa i salongen." },
      ]}
    />
  ),
});
